<template>
    <div class="article-faqs-description">
        <p>
            It's entirely normal to feel nervous before attending your first class, but don't worry - we're a friendly
            bunch and you'll soon feel perfectly at home. Here are some of the questions we get asked.
        </p>
        <p>Classes are suitable for beginners, no partner or prior experience required.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleFaqsDescription',
};
</script>
